import Swal from "sweetalert2";

function normalize_alert_message(message) {
  const normalized_message = String(message ?? '').trim();

  if (!normalized_message) {
    return '';
  }

  return normalized_message
    .replace(/^\[\s*['"]?/, '')
    .replace(/['"]?\s*\]$/, '')
    .replace(/^['"]|['"]$/g, '')
    .trim();
}


function resolveModalInstance(modal_element) {
  const existing_instance = window.bootstrap.Modal.getInstance(modal_element);
  const modal_instance = existing_instance || new window.bootstrap.Modal(modal_element);
  return modal_instance;
}

function removeBackdrop(backdrop) {
  backdrop.remove();
}

function cleanupModalBackdrop() {
  const has_visible_modal = document.querySelector(".modal.show");
  if (has_visible_modal) {
    return;
  }

  document.body.classList.remove("modal-open");
  document.body.removeAttribute("style");
  document.querySelectorAll(".modal-backdrop").forEach(removeBackdrop);
}

function showLoadingState() {
  Swal.showLoading();
}

function invokeCallback(callback) {
  if (typeof callback === "function") {
    callback();
  }
}

function handleConfirmResult(result, confirmCallback, cancelCallback) {
  const confirmed_callback = result.isConfirmed ? confirmCallback : null;
  const dismissed_callback = result.isDismissed ? cancelCallback : null;
  invokeCallback(confirmed_callback);
  invokeCallback(dismissed_callback);
}

function delayClose(duration) {
  const wait_promise = new Promise((resolve) => {
    window.setTimeout(resolve, duration);
  });
  return wait_promise;
}

export default {
  methods: {
    show_loader(message, minDisplayTime = 800) {
      const loader = {
        startTime: Date.now(),
        minDisplayTime: minDisplayTime,
        instance: null,
        isClosed: false
      };

      const loader_promise = new Promise((resolve) => {
        loader.instance = Swal.fire({
          text: message,
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            showLoadingState();
            resolve(loader);
          }
        });
      });

      return loader_promise;
    },

    async close_loader(loader) {
      if (!loader || loader.isClosed) {
        return;
      }

      const elapsed = Date.now() - loader.startTime;
      const remainingTime = loader.minDisplayTime - elapsed;

      if (remainingTime > 0) {
        await delayClose(remainingTime);
      }

      if (loader.instance && typeof loader.instance.close === "function") {
        loader.instance.close();
      }

      loader.isClosed = true;
    },

    show_error(message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        iconHtml: "!",
        title: normalize_alert_message(message),
        showConfirmButton: false,
        timer: 3200,
        timerProgressBar: false,
        showClass: {
          popup: "swal2-toast-show"
        },
        hideClass: {
          popup: "swal2-toast-hide"
        },
        customClass: {
          popup: "error-toast-popup",
          title: "error-toast-title",
          icon: "error-toast-icon",
          iconHtml: "error-toast-icon-mark"
        }
      });
    },

    show_confirm(title, text, confirmCallback, cancelCallback = null) {
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        iconHtml: "!",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          popup: "danger-confirm-popup",
          title: "danger-confirm-title",
          htmlContainer: "danger-confirm-text",
          icon: "danger-confirm-icon",
          iconHtml: "danger-confirm-icon-mark",
          actions: "danger-confirm-actions",
          confirmButton: "danger-confirm-btn danger-confirm-btn-primary",
          cancelButton: "danger-confirm-btn danger-confirm-btn-secondary"
        }
      }).then((result) => handleConfirmResult(result, confirmCallback, cancelCallback));
    },

    show_warning(title, text) {
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: true,
        confirmButtonText: "OK",
        customClass: {
          popup: "danger-confirm-popup",
          title: "danger-confirm-title",
          htmlContainer: "danger-confirm-text",
          icon: "danger-confirm-icon",
          iconHtml: "danger-confirm-icon-mark",
          actions: "danger-confirm-actions",
          confirmButton: "danger-confirm-btn danger-confirm-btn-primary"
        }
      });
    },

    show_info(message) {
      Swal.fire({
        icon: "info",
        title: "Validation!",
        text: message,
        showConfirmButton: true,
        customClass: {
          title: "small-title",
          content: "small-text"
        }
      });
    },

    show_success(message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        iconHtml: "&#10003;",
        title: message,
        showConfirmButton: false,
        timer: 2600,
        timerProgressBar: false,
        showClass: {
          popup: "swal2-toast-show"
        },
        hideClass: {
          popup: "swal2-toast-hide"
        },
        customClass: {
          popup: "success-toast-popup",
          title: "success-toast-title",
          icon: "success-toast-icon",
          iconHtml: "success-toast-icon-check"
        }
      });
    },

    close_modal(modal_id) {
      const modal_element = document.getElementById(modal_id);
      if (!modal_element) {
        return;
      }

      const modal_instance = resolveModalInstance(modal_element);
      modal_element.addEventListener("hidden.bs.modal", cleanupModalBackdrop, { once: true });
      modal_instance.hide();
      window.setTimeout(cleanupModalBackdrop, 350);
    }
  }
};
